
import React from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface InstructionsFieldProps {
  instructions: string;
  setInstructions: (value: string) => void;
}

const InstructionsField: React.FC<InstructionsFieldProps> = ({
  instructions,
  setInstructions,
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="instructions">Instructions</Label>
      <Textarea
        id="instructions"
        value={instructions}
        onChange={(e) => setInstructions(e.target.value)}
        placeholder="Enter step-by-step instructions"
        required
        rows={6}
      />
    </div>
  );
};

export default InstructionsField;
